import React, { Component } from "react";
import {Card, Form, Button, Row, Col, Alert, Tab, Tabs} from "react-bootstrap";
import api from "../../services/api";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { withRouter } from '../../common/with-router';
import AsyncSelect from 'react-select/async';
import {FaCheck} from "react-icons/fa";
import { tiposCampos } from '../../common/utils';
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'

class CamposPersonalizadosAtendimentosEdit extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.enviaRegistro = this.enviaRegistro.bind(this);

        this.fileInput = React.createRef();

        this.state = {
            erroLoadRegistro: "",
            campo_personalizado_atendimento_id: "",
            titulo_pagina: "",
            loading: false,
            programas_list: [{programa_id: null, programa__nome: '', secao: '', disclaimer: '', gerar_historico: false, exibir_filtro_exames: false}],
            doencas_list: [{doenca_id: null, doenca__nome: ''}],
            programas_register: [],
            filtra_atendimentos: false,
            nome: '',
            slug: '', 
            descricao: '', 
            ordem: '', 
            tipo: '',
            obrigatorio: '', 
            extencoes_permitidas: '', 
            opcoes: '', 
            mascara: '', 
        };
    }

    componentDidMount() {
        const id = this.props.router.params.id;
    
        if (id) {
            this.setState({
                campo_personalizado_atendimento_id: id,
                titulo_pagina: 'Editando Campo Personalizado Atendimento',
                loading: true,
                erroLoadRegistro: ''
            });

            api.get(`/atendimentos/campos/${id}/`)
            .then(response => {
                const dados = response.data;

                this.setState({
                    erroLoadRegistro: '',
                    nome: dados.nome,
                    slug: dados.slug,
                    descricao: dados.descricao,
                    ordem: dados.ordem,
                    tipo: dados.tipo,
                    obrigatorio: dados.obrigatorio,
                    extencoes_permitidas: dados.extencoes_permitidas,
                    opcoes: dados.opcoes,
                    mascara: dados.mascara,
                    filtra_atendimentos: dados.filtra_atendimentos,
                    programas_list: dados.programas_list,
                    doencas_list: dados.doencas_list,
                    loading: false
                });
            })
                .catch(error => {
                    let erro_msg = 'Erro ao carregar campos personalizados atendimentos, tente novamente';
    
                    if (error.response && error.response.status === 500) {
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }
    
                    this.setState({
                        erroLoadRegistro: erro_msg,
                        loading: false
                    });
                });
        } else {
            this.setState({
                campo_personalizado_atendimento_id: '',
                titulo_pagina: 'Adicionar Campo Personalizado Atendimento',
                loading: false,
                erroLoadRegistro: '',
            });
        }
    }

    splitMascaraTopLevel = (mascara = '') => {
        const tokens = [];
        let atual = '';
        let bracketDepth = 0;

        for (const ch of (mascara || '')) {
            if (ch === '[') bracketDepth += 1;
            if (ch === ']') bracketDepth = Math.max(0, bracketDepth - 1);

            if (ch === '|' && bracketDepth === 0) {
                tokens.push(atual);
                atual = '';
                continue;
            }

            atual += ch;
        }

        if (atual) tokens.push(atual);
        return tokens;
    };

    normalizeMascara = (mascara = '') => {
        if (!mascara || typeof mascara !== 'string') return '';

        let normalized = mascara
            .trim()
            .replace(/\s*\|\s*/g, '|')
            .replace(/\|{2,}/g, '|')
            .replace(/^\||\|$/g, '');

        normalized = normalized.replace(
            /(show-on(?:-any|-all)?\[[^\]]*?)(?=\|(information-field|policy-accept|position-bottom|divisor|context=(?:new|edit|both)|minLength=\d+|maxLength=\d+|position-(?:after|before)=))/gi,
            '$1]'
        );

        const tokens = this.splitMascaraTopLevel(normalized)
            .map(token => token.trim())
            .filter(Boolean)
            .map((token) => {
                if (/^show-on(?:-any|-all)?\[/i.test(token) && !token.includes(']')) {
                    return `${token}]`;
                }
                return token;
            });

        return tokens.join('|');
    };

    enviaRegistro = (e) => {
        e.preventDefault();

        this.setState({
            loading: true,
            tipoHelper: "",
            cidIdHelper: ""
        });

        //vererifica se é edição ou adição
        const url = (this.state.campo_personalizado_atendimento_id) ? '/atendimentos/campos/'+this.state.campo_personalizado_atendimento_id+'/' : '/atendimentos/campos/'
        const metodo = (this.state.campo_personalizado_atendimento_id) ? 'put' : 'post'

        const mascaraPayload = this.normalizeMascara(this.state.mascara || '');

        let payload = {
            nome: this.state.nome,
            slug: this.state.slug,
            tipo: this.state.tipo,
            mascara: mascaraPayload,
            filtra_atendimentos: this.state.filtra_atendimentos,
            status: true,   
            programas_register: this.state.programas_list.map(programa => ({
                programa_id: programa.programa_id,
                programa__nome: programa.programa__nome,
                secao: programa.secao,
                disclaimer: programa.disclaimer || '',
                gerar_historico: programa.gerar_historico,
                exibir_filtro_exames: programa.exibir_filtro_exames,
            }))
        };

        if(this.state.doencas_list.length > 0) {
            payload['doencas_register'] = this.state.doencas_list.map(doenca => ({
                doenca_id: doenca.doenca_id,
                doenca__nome: doenca.doenca__nome,
            }))
        }

        if(this.state.descricao) {
            payload['descricao'] = this.state.descricao;
        }

        if(this.state.ordem) {
            payload['ordem'] = this.state.ordem;
        }
        if(this.state.opcoes) {
            payload['opcoes'] = this.state.opcoes;
          }
        if(this.state.obrigatorio) {
            payload['obrigatorio'] = this.state.obrigatorio;
          }
        if(this.state.extencoes_permitidas) {
            payload['extencoes_permitidas'] = this.state.extencoes_permitidas;
          }

        //envia para api
        api({
            method: metodo,
            url: url,
            data: payload,
        })
        .then(response => {
            const MySwal = withReactContent(Swal)
            const textSwal = (this.state.campo_personalizado_atendimento_id) ? 'Campo personalizado atualizado com sucesso' : 'Campo personalizado cadastrado com sucesso';

            MySwal.fire({
                title: 'Sucesso!',
                html: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
            this.setState({
                loading: false,
            })
            
            //redireciona
            if(!this.state.campo_personalizado_atendimento_id){
                this.props.router.navigate("/campos-personalizados-atendimentos");
            }
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar campo personalizado atendimento, verifique os campos e tente novamente';            

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                for (let key in campos){
                    var value = campos[key];
                }
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
            })    
            
            this.setState({
                loading: false,
            })
        });
    };

    carregarProgramas = async (inputValue) => {
        try {
            const response = await api.get(`/programas/?nome=${inputValue}`);
            const opcoes = response.data.results.map(programa => ({
                value: programa.id,
                label: programa.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar programas:', error);
            return [];
        }
    };

    adicionarPrograma() {
        this.setState(prevState => ({
            programas_list: [...prevState.programas_list, { programa_id: null, programa__nome: '', secao: '', disclaimer: '', gerar_historico: false, exibir_filtro_exames: false }],
        }));
    }

    removerPrograma(index) {
        this.setState(prevState => ({
            programas_list: prevState.programas_list.filter((_, i) => i !== index),
        }));
    }

    carregarDoencas = async (inputValue) => {
        try {
            const response = await api.get(`/doencas/?nome=${inputValue}`);
            const opcoes = response.data.results.map(doenca => ({
                value: doenca.id,
                label: doenca.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar doenças:', error);
            return [];
        }
    };

    adicionarDoenca() {
        this.setState(prevState => ({
            doencas_list: [...prevState.doencas_list, { doenca_id: null, doenca__nome: ''}],
        }));
    }

    removerDoenca(index) {
        this.setState(prevState => ({
            doencas_list: prevState.doencas_list.filter((_, i) => i !== index),
        }));
    }

    handleChange = (event, fieldName) => {
        if(fieldName == 'programa_id') {
            const { value, label } = event;
            this.setState({
                [fieldName]: value,
                programa__nome: label,
            });
        } else {
            const { name, value } = event.target;
            this.setState({ [name]: value });
        }
    };

    handleChangePrograma(index, selectedOption) {
        this.setState(prevState => {
            const programas_list = [...prevState.programas_list];
            programas_list[index] = {
                ...programas_list[index],
                programa_id: selectedOption.value,
                programa__nome: selectedOption.label,
            };
            return { programas_list };
        });
    }

    handleSecaoChange(index, event) {
        const { value } = event.target;
        this.setState(prevState => {
            const programas_list = [...prevState.programas_list];
            programas_list[index].secao = value;
            return { programas_list };
        });
    }

    handleDisclaimerChange(index, event) {
        const { value } = event.target;
        this.setState(prevState => {
            const programas_list = [...prevState.programas_list];
            programas_list[index].disclaimer = value;
            return { programas_list };
        });
    }

    toggleGerarHistorico = (index) => {
        const programas = [...this.state.programas_list];
        programas[index] = {
            ...programas[index],
            gerar_historico: !programas[index].gerar_historico,
        };
        this.setState({ programas_list: programas });
    };

    toggleExibirFiltroExames = (index) => {
        const programas = [...this.state.programas_list];
        programas[index] = {
            ...programas[index],
            exibir_filtro_exames: !programas[index].exibir_filtro_exames,
        };
        this.setState({ programas_list: programas });
    };

    handleChangeDoenca(index, selectedOption) {
        this.setState(prevState => {
            const doencas_list = [...prevState.doencas_list];
            doencas_list[index] = {
                ...doencas_list[index],
                doenca_id: selectedOption.value,
                doenca__nome: selectedOption.label,
            };
            return { doencas_list };
        });
    }
    
    render(){
        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">{this.state.titulo_pagina}</h4>
                    </Col>
                </Row>
                <Tabs defaultActiveKey="dadosCampos" id="tabs-campos" className="aditus-tabs">
                    <Tab eventKey="dadosCampos" title="Dados do Campo Personalizado Atendimento"> 
                            <Card className="cardDestaque">
                                <Card.Body>                    
                                    <Form onSubmit={this.enviaRegistro}>
                                        <h4>Campos Personalizado Atendimento</h4>
                                                <Row>
                                                    <Col sm={6}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Nome</Form.Label>
                                                            <Form.Control 
                                                                type="text" 
                                                                name="nome" 
                                                                value={this.state.nome} 
                                                                onChange={e => this.handleChange(e, 'nome')} 
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={6}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Tipo do Campo</Form.Label>
                                                            <Form.Control as="select" name="tipo" value={this.state.tipo} required onChange={e => this.handleChange(e, 'tipo')}>
                                                                <option value="">Tipo</option>
                                                                {Object.entries(tiposCampos).map(([sigla, nome]) => (
                                                                    <option key={sigla} value={sigla}>{nome}</option>
                                                                ))}
                                                            </Form.Control>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={4}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Slug</Form.Label>
                                                            <Form.Control 
                                                                type="text" 
                                                                name="slug"
                                                                value={this.state.slug} 
                                                                onChange={e => this.handleChange(e, 'slug')} 
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={4}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Máscara para Campo</Form.Label>
                                                            <Form.Control 
                                                                type="text" 
                                                                name="mascara" 
                                                                value={this.state.mascara} 
                                                                onChange={e => this.handleChange(e, 'mascara')} 
                                                            />
                                                            <Form.Text className="text-muted" style={{fontSize: '0.9em'}}>
                                                                Possível fornecer máscara para o campo, exemplo: 99999-999
                                                            </Form.Text>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={4}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Campo Obrigatório?</Form.Label>
                                                            <Form.Select className="form-control" name="obrigatorio" value={this.state.obrigatorio.toString()} onChange={e => this.handleChange(e, 'obrigatorio')}>
                                                                <option value="false">Não</option>
                                                                <option value="true">Sim</option>
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                {(this.state.tipo == 'arquivo') && (
                                                <Row>
                                                    <Col>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Extensões Permitidas</Form.Label>
                                                            <Form.Control 
                                                                type="text" 
                                                                name="extencoes_permitidas" 
                                                                value={this.state.extencoes_permitidas} 
                                                                onChange={e => this.handleChange(e, 'extensoes_permitidas')} 
                                                            />
                                                        </Form.Group>
                                                        <Form.Text className="text-muted" style={{fontSize: '0.9em'}}>
                                                            Informe as extensões permitidas para o campo separadas por vírgula, por exemplo: .jpg, .png, .pdf
                                                        </Form.Text>
                                                    </Col>
                                                </Row>
                                                )}
                                                {(this.state.tipo == 'selecao' || this.state.tipo == 'checkbox' || this.state.tipo == 'radio') && (
                                                <Row>
                                                    <Col>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Valores do Campo</Form.Label>
                                                            <Form.Control 
                                                                as="textarea" 
                                                                name="opcoes" 
                                                                value={this.state.opcoes} 
                                                                onChange={e => this.handleChange(e, 'opcoes')} 
                                                            />
                                                            <Form.Text className="text-muted" style={{fontSize: '0.9em'}}>
                                                                Informe as opções disponíveis para escolha do campo no formato chave:valor com um item por linha. Por exemplo, para um campo para escolha de cor as opções poderiam ser:<br />
                                                                vermelho:Vermelho<br />
                                                                azul:Azul<br />
                                                                verde:Verde
                                                            </Form.Text>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                )}
                                                <Col sm={4} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Filtrar por Atendimento?</Form.Label>
                                                        <div>
                                                            <Button 
                                                                variant={this.state.filtra_atendimentos ? "success" : "outline-secondary"}
                                                                onClick={() => this.setState({ filtra_atendimentos: true })}>
                                                                Sim
                                                            </Button>
                                                            {' '}
                                                            <Button 
                                                                variant={!this.state.filtra_atendimentos ? "danger" : "outline-secondary"}
                                                                onClick={() => this.setState({ filtra_atendimentos: false })}>
                                                                Não
                                                            </Button>
                                                        </div>
                                                    </Form.Group>
                                                </Col>
                                                <Row>
                                                    <Col>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Descrição</Form.Label>
                                                            <Form.Control 
                                                                as="textarea" 
                                                                name="descricao" 
                                                                value={this.state.descricao} 
                                                                onChange={e => this.handleChange(e, 'descricao')} 
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <h4 className="mt-3">Programas</h4>
                                                {this.state.programas_list.map((programa, index) => (
                                                    <div key={index}>
                                                        <Row>
                                                            <Col sm={4} xs={12}>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Programa</Form.Label>
                                                                    <AsyncSelect
                                                                        cacheOptions
                                                                        loadOptions={this.carregarProgramas}
                                                                        defaultOptions
                                                                        name="programa_id"
                                                                        placeholder="Buscar programa..."
                                                                        noOptionsMessage={() => "Nenhum programa encontrado"}
                                                                        onChange={e => this.handleChangePrograma(index, e)}
                                                                        value={programa.programa_id ? { value: programa.programa_id, label: programa.programa__nome } : null}
                                                                    />
                                                                    <Form.Text id="formProgramaHelpBlock" className="text-danger">{this.state.programaHelper}</Form.Text>
                                                                </Form.Group>
                                                            </Col>
                                                            {programa.programa_id && (
                                                                <>
                                                                    <Col sm={4} xs={12}>
                                                                        <Form.Group className="mb-3">
                                                                            <Form.Label>Seção</Form.Label>
                                                                            <Form.Control 
                                                                                type="text" 
                                                                                name="secao" 
                                                                                value={programa.secao} 
                                                                                onChange={e => this.handleSecaoChange(index, e)} 
                                                                            />
                                                                        </Form.Group>
                                                                    </Col>
                                                                    <Col sm={4} xs={12}>
                                                                        <Form.Group className="mb-3">
                                                                            <Form.Label>Disclaimer</Form.Label>
                                                                            <Form.Control 
                                                                                type="text" 
                                                                                name="disclaimer" 
                                                                                value={programa.disclaimer} 
                                                                                onChange={e => this.handleDisclaimerChange(index, e)} 
                                                                            />
                                                                        </Form.Group>
                                                                    </Col>
                                                                </>
                                                            )}
                                                            {programa.programa_id && (
                                                                <Col >
                                                                    <Form.Group className="mb-3">
                                                                        <Form.Check 
                                                                            type="checkbox" 
                                                                            label="Gerar Histórico" 
                                                                            checked={programa.gerar_historico || false}
                                                                            onChange={() => this.toggleGerarHistorico(index)}
                                                                        />
                                                                    </Form.Group>
                                                                    <Form.Group className="mb-3">
                                                                        <Form.Check 
                                                                            type="checkbox" 
                                                                            label="Exibir no filtro de Exames?" 
                                                                            checked={programa.exibir_filtro_exames || false}
                                                                            onChange={() => this.toggleExibirFiltroExames(index)}
                                                                        />
                                                                    </Form.Group>
                                                                </Col>
                                                                
                                                            )}
                                                        </Row>
                                                    </div>
                                                ))}
                                                <Row>
                                                    <Col sm={2} xs={12}>
                                                        <Button variant="secondary" className="btn-sm" onClick={() => this.adicionarPrograma(0)}>Adicionar Programa</Button>
                                                    </Col>
                                                    <Col sm={3} xs={12}>
                                                        <Button variant="danger" className="btn-sm" onClick={() => this.removerPrograma(0)}> Remover Programa</Button>
                                                    </Col>
                                                </Row>
                                                <h4 className="mt-3">Doenças</h4>
                                                {this.state.doencas_list.map((doenca, index) => (
                                                    <div key={index}>
                                                        <Row>
                                                            <Col sm={4} xs={12}>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Doença</Form.Label>
                                                                    <AsyncSelect
                                                                        cacheOptions
                                                                        loadOptions={this.carregarDoencas}
                                                                        defaultOptions
                                                                        name="doença_id"
                                                                        placeholder="Buscar doença..."
                                                                        noOptionsMessage={() => "Nenhuma doença encontrada"}
                                                                        onChange={e => this.handleChangeDoenca(index, e)}
                                                                        value={doenca.doenca_id ? { value: doenca.doenca_id, label: doenca.doenca__nome } : null}
                                                                    />
                                                                    <Form.Text id="formProgramaHelpBlock" className="text-danger">{this.state.programaHelper}</Form.Text>
                                                                </Form.Group>
                                                            </Col>

                                                        </Row>
                                                    </div>
                                                ))}
                                                <Row>
                                                    <Col sm={2} xs={12}>
                                                        <Button variant="secondary" className="btn-sm" onClick={() => this.adicionarDoenca(0)}>Adicionar Doença</Button>
                                                    </Col>
                                                    <Col sm={3} xs={12}>
                                                        <Button variant="danger" className="btn-sm" onClick={() => this.removerDoenca(0)}> Remover Doença</Button>
                                                    </Col>
                                                </Row>
                                                <br></br>
                                                <Row>
                                                    <Col sm={4}>
                                                        <Button variant="success" className="btn-sm" onClick={this.enviaRegistro}>
                                                            <FaCheck className="me-1" /> Salvar Campo
                                                        </Button>&nbsp;&nbsp;
                                                    </Col>
                                                </Row>
                                    </Form> 
                                </Card.Body>                
                            </Card>
                    </Tab>
                </Tabs>
            </div>
        )
    }
}

export default withRouter(CamposPersonalizadosAtendimentosEdit);